import { DateTime } from 'luxon';

const isAfterNextTime = (nextTime) => nextTime < DateTime.local();

export default isAfterNextTime;
